module.exports = __webpack_public_path__ + "static/media/hand-phone.d620646a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/hand-phone.svg
// module id = 1866
// module chunks = 0